import { EditOutlined } from "@ant-design/icons";
import { Form, Modal } from "antd";
import React from "react";
import { ContentModalSaveConfig } from "./content-modal-save-config";
import { FormInstance } from "antd/lib";
import { IntelligenceFormFieldsEnum } from "../../enum";
import { FieldErrorWhenSave } from "./field-error-when-save";

export const DEFAULT_TITLE = "New question";
export const TitleConfig: React.FC<{ form: FormInstance<any> }> = ({ form }) => {
  const [errorsField, setErrorsField] = React.useState<string[]>([]);
  const [titleConfig, setTitleConfig] = React.useState<{
    title?: string;
    description?: string;
  }>();
  const [open, setOpen] = React.useState(false);

  const handleOk = () => {
    const title = titleConfig?.title;
    const description = titleConfig?.description;

    const _errorsField: string[] = [];
    if (!title) {
      _errorsField.push("Please input title!");
      setErrorsField(_errorsField);
      return;
    }

    form.setFieldsValue({
      [IntelligenceFormFieldsEnum.TITLE]: title,
      [IntelligenceFormFieldsEnum.DESCRIPTION]: description,
    });
    setErrorsField([]);
    setOpen(false);
  };
  const titleWatch = Form.useWatch(IntelligenceFormFieldsEnum.TITLE, form);
  const descriptionWatch = Form.useWatch(IntelligenceFormFieldsEnum.DESCRIPTION, form);

  const handleUpdateSoftTitleConfig = React.useCallback((title?: string, description?: string) => {
    setTitleConfig({
      title: title,
      description: description,
    });
  }, []);
  return (
    <div className=" ">
      <div>
        <span className="text-[18px] font-semibold  ">{titleWatch} </span>
        <EditOutlined
          className="text-blue-500"
          onClick={() => {
            setOpen(true);
          }}
        />
      </div>

      <span className="text-[12px] text-gray-500">{descriptionWatch} </span>
      <Modal
        destroyOnHidden
        centered
        title="Update title"
        open={open}
        onCancel={() => {
          setOpen(false);
          setErrorsField([]);
        }}
        onOk={handleOk}
      >
        <FieldErrorWhenSave errorFields={errorsField} />
        <ContentModalSaveConfig
          form={form}
          handleUpdateSoftTitleConfig={handleUpdateSoftTitleConfig}
          showMode={false}
        />
      </Modal>
    </div>
  );
};
